import React from 'react';
import { FadeIn } from '../ui/FadeIn';
import { CheckCircle2, XCircle } from 'lucide-react';
export function Objections() {
  const forYou = ['Nunca tocaste piano', 'Pensás que es difícil', 'No entendés teoría musical', 'Querés aprender de forma simple'];
  const notForYou = ['Buscás formación profesional', 'Querés teoría musical avanzada'];
  return <section className="py-16 bg-navy relative overflow-hidden" data-id="element-115">
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[500px] h-[500px] bg-gold/5 rounded-full blur-3xl pointer-events-none" data-id="element-116"></div>

      <div className="container mx-auto px-4 max-w-4xl relative z-10" data-id="element-117">
        <FadeIn data-id="element-118">
          <h2 className="text-3xl md:text-4xl font-black text-center text-beige mb-10" data-id="element-119">
            ¿Es para <span className="text-gold" data-id="element-120">vos</span>?
          </h2>
        </FadeIn>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-5" data-id="element-121">
          <FadeIn data-id="element-122">
            <div className="bg-navy-light border border-green-500/20 rounded-2xl p-6 md:p-7 h-full" data-id="element-123">
              <h3 className="text-xl font-bold text-beige mb-5 flex items-center gap-2" data-id="element-124">
                <CheckCircle2 className="w-6 h-6 text-green-400" data-id="element-125" />
                Es para vos si…
              </h3>
              <ul className="space-y-3" data-id="element-126">
                {forYou.map((item, index) => <li key={index} className="flex items-center gap-3 text-base text-beige/85" data-id="element-127">
                    <span className="w-2 h-2 rounded-full bg-green-400 flex-shrink-0" data-id="element-128"></span>
                    {item}
                  </li>)}
              </ul>
            </div>
          </FadeIn>

          <FadeIn delay={0.15} data-id="element-129">
            <div className="bg-navy-light border border-red-500/20 rounded-2xl p-6 md:p-7 h-full" data-id="element-130">
              <h3 className="text-xl font-bold text-beige mb-5 flex items-center gap-2" data-id="element-131">
                <XCircle className="w-6 h-6 text-red-400" data-id="element-132" />
                NO es para vos si…
              </h3>
              <ul className="space-y-3" data-id="element-133">
                {notForYou.map((item, index) => <li key={index} className="flex items-center gap-3 text-base text-beige/85" data-id="element-134">
                    <span className="w-2 h-2 rounded-full bg-red-400 flex-shrink-0" data-id="element-135"></span>
                    {item}
                  </li>)}
              </ul>
            </div>
          </FadeIn>
        </div>
      </div>
    </section>;
}